import script from "./Carcass.vue?vue&type=script&lang=ts&setup=true"
export * from "./Carcass.vue?vue&type=script&lang=ts&setup=true"

import "./Carcass.vue?vue&type=style&index=0&id=47ec83f4&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47ec83f4"]])

export default __exports__